<h2 mat-dialog-title>Manage Service Location: {{ data.geofence.name }}</h2>

<mat-dialog-content>
  <p class="description">Choose component types for this service location</p>

  @if (isLoading) {
  <div class="loading-container">Loading component types...</div>
  } @if (!isLoading && componentTypes.length === 0) {
  <div class="empty-state">No component types configured for this service location</div>
  } @if (!isLoading && componentTypes.length > 0) {
  <mat-list class="component-type-list">
    @for (componentType of componentTypes; track componentType) {
    <mat-list-item class="component-type-item">
      <div class="item-content">
        <div class="type-info">
          <strong>{{ componentType.name }}</strong>
          @if (componentType.description) {
          <p class="type-description">{{ componentType.description }}</p>
          }
        </div>
        <button mat-icon-button color="warn" (click)="removeComponentType(componentType)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-list-item>
    }
  </mat-list>
  } @if (!isLoading) {
  <button mat-flat-button color="primary" (click)="addComponentType()" class="add-type-btn">
    <mat-icon>add</mat-icon>
    Add Component Type
  </button>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" cdkFocusInitial>Close</button>
</mat-dialog-actions>
